import React, { FC } from 'react';
import MuiDivider, { DividerProps } from '@material-ui/core/Divider';

export const Divider: FC<DividerProps> = (props) => <MuiDivider {...props} />;
